"use client"

import { View, StyleSheet, ScrollView } from "react-native"
import { Text, useTheme } from "react-native-paper"
import { HorizontalSection } from "./HorizontalSection"
import type { TreeNode } from "../../types/project"

// Define the order of importance for groups
const GROUP_ORDER = [
  "Basic Information",
  "Circuit Details",
  "Line Items",
  "Structure Details",
  "Foundation Details",
  "Earthing Details",
  "Site works",
  "OPGW Installation Assembly",
  "Aviation Lights",
  "Line crossing Details",
]

interface NodeSummaryContentProps {
  node: TreeNode
}

export function NodeSummaryContent({ node }: NodeSummaryContentProps) {
  const theme = useTheme()

  // Only display summary for "line" node type
  if (node.type !== "line") {
    return (
      <View style={[styles.emptyContainer, { backgroundColor: theme.colors.background }]}>
        <Text style={[styles.emptyMessage, { color: theme.colors.onSurfaceVariant }]}>
          Please select a line node to display summary information.
        </Text>
      </View>
    )
  }

  if (!node.summary) {
    return (
      <View style={[styles.emptyContainer, { backgroundColor: theme.colors.background }]}>
        <Text style={[styles.emptyMessage, { color: theme.colors.onSurfaceVariant }]}>
          No summary information available for this line.
        </Text>
      </View>
    )
  }

  // Original code for displaying summary (only for line nodes)
  // Sort groups by importance
  const sortedGroups = Object.entries(node.summary).sort(([a], [b]) => {
    const aIndex = GROUP_ORDER.indexOf(a)
    const bIndex = GROUP_ORDER.indexOf(b)
    if (aIndex === -1 && bIndex === -1) return 0
    if (aIndex === -1) return 1
    if (bIndex === -1) return -1
    return aIndex - bIndex
  })

  return (
    <ScrollView style={styles.container}>
      <View style={styles.content}>
        {sortedGroups.map(([groupName, groupContent]) => (
          <HorizontalSection
            key={groupName}
            title={groupName}
            content={groupContent}
            defaultExpanded={groupName === "Basic Information"}
          />
        ))}
      </View>
    </ScrollView>
  )

  /* Commented out original code for future reference
  if (!node.summary) {
    return null
  }

  // Sort groups by importance
  const sortedGroups = Object.entries(node.summary).sort(([a], [b]) => {
    const aIndex = GROUP_ORDER.indexOf(a)
    const bIndex = GROUP_ORDER.indexOf(b)
    if (aIndex === -1 && bIndex === -1) return 0
    if (aIndex === -1) return 1
    if (bIndex === -1) return -1
    return aIndex - bIndex
  })

  return (
    <ScrollView style={styles.container}>
      <View style={styles.content}>
        {sortedGroups.map(([groupName, groupContent]) => (
          <HorizontalSection
            key={groupName}
            title={groupName}
            content={groupContent}
            defaultExpanded={groupName === "Basic Information"}
          />
        ))}
      </View>
    </ScrollView>
  )
  */
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    padding: 16,
  },
  emptyContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 24,
  },
  emptyMessage: {
    fontSize: 16,
    textAlign: "center",
    opacity: 0.8,
  },
})

